import { render } from "./ActivationPrompt.vue?vue&type=template&id=8f91b348&scoped=true&ts=true"
import script from "./ActivationPrompt.vue?vue&type=script&lang=ts"
export * from "./ActivationPrompt.vue?vue&type=script&lang=ts"

import "./ActivationPrompt.vue?vue&type=style&index=0&id=8f91b348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f91b348"]])

export default __exports__